import { useEffect, useState } from "react";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import { sentenceCase } from "change-case";

const SUPPORTED_TYPES = [
  "text",
  "number",
  "radiogroup",
  "checkbox",
  "dropdown",
  "tagbox",
  "gpsCoordinates",
];

const useAvailableColumns = (reportId: number | undefined) => {
  const [availableColumns, setAvailableColumns] = useState<IColumn[]>([]);
  const [isColumnsLoading, setIsColumnsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const getColumnsByReport = async () => {
      if (!reportId) return;
      setIsColumnsLoading(true);
      try {
        const { data } = await apiLibrary.Reports.AddReportApis.getReportColumns(
          reportId
        );
        const filtered: IColumn[] = data.availableColumns
          .filter((column: IColumn) => SUPPORTED_TYPES.includes(column.columnType))
          .map((column: IColumn) => ({
            column: column.columnName,
            type: column.columnName === "status" ? "dropdown" : column.columnType,
            title: column.columnTitle,
            inputType:
              column.columnType === "gpsCoordinates"
                ? column.columnType
                : column.inputType ?? "text",
            metaInfo: column.metaInfo,
          }));
        if (isMounted) setAvailableColumns(filtered);
      } catch (error: any) {
        const errorMsg = error?.response?.data?.message ?? error?.message;
        Toasts.error(sentenceCase(errorMsg ?? ""));
      } finally {
        if (isMounted) setIsColumnsLoading(false);
      }
    };

    getColumnsByReport();
    return () => {
      isMounted = false;
      setAvailableColumns([]);
    };
  }, [reportId]);

  return { availableColumns, isColumnsLoading };
};

export default useAvailableColumns;
import { IColumn } from "./types";
